import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchNkBranches} from 'api';
import {rootDomain} from 'core/rootDomain';
import {NkBranch} from 'types';

const domain = rootDomain.createDomain('branchesNkDomain');

export const Gate = createGate('BranchesNkGate');
export const fetchBranchesFx = domain.createEffect({
    name: 'fetchBranchesNkFx',
    handler: fetchNkBranches,
});

export const branches$ = domain.createStore<NkBranch[]>([]);

export const branchesNkState$ = combine({
    branches: branches$,
    isLoading: fetchBranchesFx.pending,
});
